import { clsx } from 'clsx';
import React from 'react';
import styles from './SelectGroup.module.scss';

import {
  Header,
  ListBoxSection,
  type ListBoxSectionProps,
} from 'react-aria-components';

export type SelectGroupProps<T extends object> = ListBoxSectionProps<T> & {
  /** The content to label a group of items. */
  label: string;
  /** `Select.Item`s to render within the group. */
  children: React.ReactNode;
};

/**
 * Used to group multiple `Select.Item`s.
 */
export const SelectGroup = <T extends object = object>({
  children,
  className,
  label,
  ...otherProps
}: SelectGroupProps<T>) => {
  return (
    <ListBoxSection<T>
      className={clsx(className, styles.section)}
      {...otherProps}
      data-zds
    >
      <Header className={styles.header} data-zds>
        {label}
      </Header>
      {/* TODO: handle children function prop */}
      {children}
    </ListBoxSection>
  );
};
